import React, { CSSProperties, FC } from 'react';
import Link, { LinkProps } from 'next/link';
import { getPreparedUrl } from '@nx-frontend/shared/utils';

export interface SharedLinkBaseProps extends LinkProps {
  'href': string;
  'children'?: React.ReactNode;
  'key'?: number | string;
  'className'?: string;
  'style'?: CSSProperties;
  'target'?: string;
  'data-cy'?: string;
  'base'?: string;
  'title'?: string;
  'useSimpleLink'?: boolean;
  'searchParams'?: {
    [k: string]: string;
  };
}

export const SharedLinkBase: FC<SharedLinkBaseProps> = ({
  children,
  href,
  base = '',
  searchParams = {},
  scroll = false,
  className = undefined,
  style,
  target = undefined,
  title = undefined,
  prefetch = false,
  useSimpleLink = false,
  'data-cy': dataCy,
  onClick,
}) => {
  const url = getPreparedUrl({ href, base, searchParams });
  const params = { 'href': url, target, title, style, className, 'data-cy': dataCy || undefined, onClick };
  return useSimpleLink ? (
    <a {...params}>{children}</a>
  ) : (
    <Link {...params} scroll={scroll} prefetch={prefetch}>
      {children}
    </Link>
  );
};
